import React from 'react';
import { FileUploadProvider } from './FileUploadContext';
import  {CustomReportDesign } from './CustomReportDesign';

const CustomReportMain = () => {
  return (
    <FileUploadProvider>
      <CustomReportDesign />
    </FileUploadProvider>
  );
};

export default CustomReportMain;